import { LicenseStatusTypes } from './license';
import { BillingCycleTypes } from './invoice';
import { SortItem } from '../ss-api/responses/member.dashboard.license.response';
import { ISortable } from '../../helpers/sort';

export enum HoldTypes {
    NoHold = 0,
    ScheduledHold = 1,
    CurrentHold = 2
}

export interface IGlobalSearchResults<T> {

    MaxRecords: number;
    SkippedRecords: number;
    TotalRecordsAvailable: number;
    Records: number;
    Data: T;
}

export class GlobalSearchResults<T> implements IGlobalSearchResults<T> {

    MaxRecords: number;
    SkippedRecords: number;
    TotalRecordsAvailable: number;
    Records: number;
    Data: T;
}

export interface IAdvancedSearchResultMemberItem {

    ID: number;

    FirstName: string;
    LastName: string;

    Email: string;
    CompanyName: string;
    MemberType: number;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    Tags: string;

    ParentMemberID: number;
    ParentMemberFirstName: string;
    ParentMemberLastName: string;


    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;

    License: AdvancedSearchResultLicenseItem;

    // BILLING
    CreditCardLastFour: string;

    IsSitePlanUser: boolean;
}


export class AdvancedSearchResultMemberItem implements IAdvancedSearchResultMemberItem {

    ID: number;
    FirstName: string;
    LastName: string;
    Email: string;
    CompanyName: string;
    MemberType: number;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    CreditCardLastFour: string;
    Tags: string;

    ParentMemberID: number;
    ParentMemberFirstName: string;
    ParentMemberLastName: string;


    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;

    License: AdvancedSearchResultLicenseItem;
    
    IsSitePlanUser: boolean;

    public static FixDate(item: AdvancedSearchResultMemberItem) {
        if (item.License != undefined)
            AdvancedSearchResultLicenseItem.FixDate(item.License);
    }

}



export interface IAdvancedSearchResultLicenseItem {
    LicenseID: number;
    Key: string;
    Version: string;
    DesignerName: string;
    ProductID: number;
    ProductName: string;
    Status: LicenseStatusTypes;
    BillingCycle: BillingCycleTypes;
    NextBillDate: Date;
    CreationDate: Date;
    CancellationDate: Date;
    SalesRepID: number[];
    SalesRepName: string;
    HoldType: HoldTypes;
    IsAssigned: boolean;
    BillingAmount: number;

}

export class AdvancedSearchResultLicenseItem implements IAdvancedSearchResultLicenseItem {
    LicenseID: number;
    Key: string;
    Version: string;
    DesignerName: string;
    ProductID: number;
    ProductName: string;
    Status: LicenseStatusTypes;
    BillingCycle: BillingCycleTypes;
    NextBillDate: Date;
    CreationDate: Date;
    CancellationDate: Date;
    SalesRepID: number[];
    SalesRepName: string;
    HoldType: HoldTypes;
    IsAssigned: boolean;

    BillingAmount: number;

    public static FixDate(item: AdvancedSearchResultLicenseItem) {
        item.CancellationDate = new Date(item.CancellationDate);
        item.CreationDate = new Date(item.CreationDate);
        item.NextBillDate = new Date(item.NextBillDate);
    }
}

export class AdvancedSearchResultLicenseItemArray extends Array<AdvancedSearchResultLicenseItem>  {

    constructor(...items: AdvancedSearchResultLicenseItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdvancedSearchResultLicenseItemArray.prototype);
    }

}

export class AdvancedSearchResultMemberItemArray extends Array<AdvancedSearchResultMemberItem> implements ISortable {

    public LastSort = new SortItem;

    constructor(...items: AdvancedSearchResultMemberItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdvancedSearchResultMemberItemArray.prototype);
    }

    public static FixDates(items: AdvancedSearchResultMemberItemArray) {
        if (items)
            items.forEach(x => AdvancedSearchResultMemberItem.FixDate(x));
    }


}
